import React from "react";
import { Table, Row } from "react-bootstrap";
import BidCard from "../../components/bidcard/BidCard";
import { get, getSocketApi } from "../../../../config/services/api/ApiServices";
import NotFound from "../../../notfound/Indesx";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { RootState } from "../../../../store/Index";
import Loader from "../../../trips/components/loader/Index";
import { FetchUserData } from "../../../../common/functions/CommonFunctions";
import TableHeader from "../../components/Tableheader";


const NotParticipated = (props?: any) => {
    const dispatch = useAppDispatch();
    FetchUserData(dispatch)

    const user = useAppSelector((state: any) => state.user);
    const auth = useAppSelector((state: RootState) => state.auth);
    const location = useAppSelector((state: RootState) => state.location);
    const socketAuth = useAppSelector((state: RootState) => state.socket.socketAuth);

    const [notParticipatedBids, setNotParticipatedBids] = React.useState([])
    const [loading, setLoading] = React.useState(false)

    React.useEffect(() => {
        getNotParticipatedBids()
    }, [])

    const getNotParticipatedBids = async () => {
        setLoading(true)
        const path = 'auction'
        const body = {
            "UserID": user.userID,
            "TransporterID": user.transporterID,
            "Type": "on going",
            "Page": 1,
            "Search": '',
            "Sort": "notParticipated",
        }
        const response = await getSocketApi(path, body, socketAuth)
        setLoading(false)
        if (response.status == 200) {
            var ndata = response.data.filter((item: any) => item.rank === null);
            setNotParticipatedBids(ndata)
        }
    }

    return (
        <Row className="contentArea p-0 m-0 ">
            {loading ? <Loader /> : (
                <>
                    {notParticipatedBids.length > 0 ? (
                        <>
                            <Table className="table">
                                <TableHeader />
                                <tbody>
                                    {notParticipatedBids.map((bids: any) => <BidCard data={bids} key={bids.id} tabName='notParticipated' />)}
                                </tbody>
                            </Table >
                        </>
                    ) : <NotFound />}
                </>)
            }
        </Row>
    )
}

export default NotParticipated